import ShoppingCartComponent from '../components/shopping-cart/shoppingCart'

const ShoppingCart = () => <ShoppingCartComponent />

export default ShoppingCart;